import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components
import BookIcon from '@material-ui/icons/Book';
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import Button from "components/CustomButtons/Button.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import NavPills from "components/NavPills/NavPills.js";
import Parallax from "components/Parallax/Parallax.js";


import profile from "assets/img/faces/john.jpg";


import styles from "assets/jss/material-kit-react/views/profilePage.js";
import SportsFootball from "@material-ui/icons/SportsFootball"
import Train from "@material-ui/icons/Train"
import Code from "@material-ui/icons/Code"
import sinatra from "assets/img/sinatra.png"
import rails from "assets/img/rails.png"
import javascript from "assets/img/javascript.png"


const useStyles = makeStyles(styles);

export default function ProfilePage(props) {
  const classes = useStyles();
  const { ...rest } = props;
  const imageClasses = classNames(
    classes.imgRaised,
    classes.imgRoundedCircle,
    classes.imgFluid
  );
  const navImageClasses = classNames(classes.imgRounded, classes.imgGallery);
  
  return (
    <div>
      <Header
        color="transparent"
        brand="Portfolio"
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 200,
          color: "white"
        }}
        {...rest}
      />
      <Parallax small filter image={require("assets/img/profile-bg.jpg")} />
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div>
          <div className={classes.container}>
            <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={6}>
                <div className={classes.profile}>
                  <div>
                    <img src={profile} alt="..." className={imageClasses} />
                  </div>
                  <div className={classes.name}>
                    <h3 className={classes.title}>John Glennan</h3>
                    <h6>Full Stack Web Developer</h6>
                    <Button justIcon link href='https://github.com/glennanj1' className={classes.margin5}>
                      <i className={"fab fa-github"} />
                    </Button>
                    <Button justIcon link className={classes.margin5}>
                      <BookIcon />
                    </Button>
                  </div>
                </div>
              </GridItem>
            </GridContainer>
            <div className={classes.description}>
              <p>
                A Bit <i>about</i> me: 
                La Salle University graduate with a Bachelor of Science. 
                I started attending flatiron school in December 2020 to 
                chase my dreams as a Web Developer. I'm thankful for all 
                the support along the way. Here is a portfolio using React. {" "}
              </p>
            </div>
            <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={8} className={classes.navWrapper}>
                <NavPills
                  alignCenter
                  color="primary"
                  tabs={[
                    {
                      tabButton: "Sinatra",
                      tabIcon: SportsFootball,
                      tabContent: (
                        <div>
                                <h2>Ruby with Sinatra. SportsBook with simple user login</h2>
                                <a href="https://top-sports-tracker.herokuapp.com/">
                                      <img
                                        alt="..."
                                        src={sinatra}
                                        className={navImageClasses}
                                      />
                                </a>
                        </div>
                      
                      )
                    },
                    {
                      tabButton: "Rails",
                      tabIcon: Train,
                      tabContent: (
                        <div>

                          <h2>Ruby on Rails that uses Facebook Authentication</h2>
                         
                          <a href='https://top-sports-book-rails.herokuapp.com/'><img
                                alt="..."
                                src={rails}
                                className={navImageClasses}
                                
                          /></a>
                        </div>
                      )
                    },
                    {
                      tabButton: "JavaScript",
                      tabIcon: Code,
                      tabContent: (
                        <div>
                          
                          <h2>My first JavaScript Project</h2>
                      
                            <a href="https://jolly-davinci-edd6d5.netlify.app/"><img
                                  alt="..."
                                  src={javascript}
                                  className={navImageClasses}
                                  
                            /></a>
                          </div>
                        
                      )
                    }
                  ]}
                />
              </GridItem>
            </GridContainer>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
